import React, { useState, useRef, useEffect } from "react";
import "./certificate.css";
import WmModals from "../modals/Wm.Modals";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Required from "../Components/required/Required"
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Certificatecard from "./Certificate.card";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import Loading from "../Loading/Loading";
import { useMutation, useQuery, useQueryClient, } from "react-query";
import { addCertification, getUserDetail } from "../functions/details";
import ServerError from "../Pages/error/500/ServerError";
const Cookie = new Cookies();
function Certificate() {
  const queryClient = useQueryClient()
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => {history.push("/login");};
  const [isEducationModal, setIsEducationModal] = useState(false);
  const [certData, setCertData] = useState([]);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({title: '', date: '', description: '', mediaSend: '', media: dummy });
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const reset = () => {
    setPortfolioData({title: '', date: '', description: '', mediaSend: '', media: dummy })
  }
  const { isError, isLoading, isSuccess, error } = useQuery(['certificationData', 'CERT' ,'PROFILE'], getUserDetail, { refetchOnWindowFocus: false, onSuccess: data => { setCertData(data[0]) } })
  const addCertificateData = useMutation(data => addCertification(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('certificationData')
      const previousValue = queryClient.getQueryData('certificationData')
      return previousValue
    },
    onError: (previousValue) =>
      queryClient.setQueryData('certificationData', previousValue),
    onSuccess: () => {
      queryClient.invalidateQueries('certificationData')
      reset();
      setIsEducationModal(false)
    },
  })
  if (isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} /></div></>
  if(isSuccess) return (
    <React.Fragment>
      {token ? (
        <React.Fragment>
          <div className="education container-fluid mb-10 md:mb-0">
            <div className="about_head">
              <span className="block manpro font-semibold text-3xl mb-3">Certificate</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {certData?.map((certData, idx) => {
                return <Certificatecard key={idx} certData={certData}/>
              })}
            </div>
            <div className="mt-10 text-center flex flex-col items-center">
              <Fab size="small" aria-label="add" className="bg-color-2 color-1 mb-2" onClick={() => setIsEducationModal(true)}>
                <AddIcon />
              </Fab>
              <p className="cursor-pointer inline-block text-sm">Add New</p>
            </div>
          </div>
        </React.Fragment>
      ) : (
        backToLoginPage()
      )}
      <WmModals show={isEducationModal} onHide={() => setIsEducationModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Add Certificate Detail</h5>
        <form onSubmit={(e) => { e.preventDefault(); addCertificateData.mutate(portfolioData) }}>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Certificate Title <Required /></label>
            <input placeholder="Certificate Title" type="text" name="title" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }}/>
          </div>
          <Row>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Date Recived <Required /></label>
                <input placeholder="Date Recived" type="date" name="start_date" className="wm_form_input border-bottom border-gray-300" required value={portfolioData.date} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.date = e.target.value; return { ...prevData } }) }}/>
              </div>
            </Col>
            <Col md={12}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Description</label>
                <textarea placeholder="Description" name="description" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} className="wm_form_input border-bottom border-gray-300" onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
                <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
              </div>
            </Col>
            <Col md={7}>
              <div className="wm_form_group flex mb-4 items-center">
                <div className="flex flex-col mr-4">
                  <label className="wm_form_label">Media <Required /></label>
                  <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg"/>
                  <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                    <img className="object-cover" src={portfolioData.media} alt="education" />
                  </div>
                </div>
                <Tooltip title={<React.Fragment>This media will be displayed in public profile And you can toggle to switch off the visibility</React.Fragment>} placement="right">
                  <HelpIcon />
                </Tooltip>
              </div>
            </Col>
          </Row>
          <div className="wm_form_group">
            <Wmbutton label={addCertificateData.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Save")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border"/>
            <Wmbutton label="Cancel" onClick={() => { setIsEducationModal(false); reset() }} className="rounded w-20" type="button" color="primary"/>
          </div>
        </form>
      </WmModals>
    </React.Fragment>
  );
}
export default Certificate;
